import { useState, useEffect } from 'react';
import { CARD_CONFIG } from '../constants/meals';

const getMealContainerWidth = (mealType) => {
    const mealContainer = document.querySelector(`[data-meal-type="${mealType}"]`);
    if (mealContainer) {
        const width = mealContainer.offsetWidth;
        return width;
    }
    return 1000; // fallback
};

export const useScrollArrows = () => {
    const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
    const [scrollPositions, setScrollPositions] = useState({});

    useEffect(() => {
        const handleResize = () => setViewportWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const shouldShowArrows = (itemCount, mealType) => {
        const cardWidth = CARD_CONFIG.WIDTH + CARD_CONFIG.GAP;
        const actualContainerWidth = getMealContainerWidth(mealType);
        const maxCards = Math.floor(actualContainerWidth / cardWidth);
        return itemCount > maxCards;
    };

    const updateScrollPosition = (mealType, scrollLeft, scrollWidth, clientWidth) => {
        setScrollPositions(prev => ({
            ...prev,
            [mealType]: {
                scrollLeft,
                scrollWidth,
                clientWidth,
                canScrollLeft: scrollLeft > 5, // 5px tolerance
                canScrollRight: scrollLeft < (scrollWidth - clientWidth - 5) // 5px tolerance
            }
        }));
    };

    const getScrollState = (mealType) => {
        return scrollPositions[mealType] || {
            canScrollLeft: false,
            canScrollRight: true
        };
    };

    const scrollLeft = (mealType) => {
        const container = document.querySelector(`[data-meal-type="${mealType}"]`);
        if (container) {
            container.scrollBy({ left: -300, behavior: 'smooth' });
        }
    };

    const scrollRight = (mealType) => {
        const container = document.querySelector(`[data-meal-type="${mealType}"]`);
        if (container) {
            container.scrollBy({ left: 300, behavior: 'smooth' });
        }
    };

    const handleScroll = (mealType, event) => {
        const container = event.target;
        updateScrollPosition(
            mealType,
            container.scrollLeft,
            container.scrollWidth,
            container.clientWidth
        );
    };

    const initializeScrollPositions = (mealTypes) => {
        mealTypes.forEach(mealType => {
            const container = document.querySelector(`[data-meal-type="${mealType}"]`);
            if (container) {
                updateScrollPosition(
                    mealType,
                    container.scrollLeft,
                    container.scrollWidth,
                    container.clientWidth
                );
            }
        });
    };

    return {
        shouldShowArrows,
        updateScrollPosition,
        getScrollState,
        scrollLeft,
        scrollRight,
        handleScroll,
        initializeScrollPositions,
        viewportWidth
    };
};